import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DefaultLoading from "../../../components/DefaultLoading";
import { getTests } from "../../../redux/actions/TestListActions";
import { addTestDetails } from "../../../redux/actions/TestActions";

import { defaultDateFormatWithTime } from "../../../utils/DefaultDateFormats";
import style from "./style.module.css"
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../../components/NoDataFound";
const Exams = () => {
    const TestListReducer = useSelector(store => store.TestListReducer)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)

    const selectTest = (testData) => {
        dispatch(addTestDetails(testData))
        navigate("/systemCheck")
    }

    useEffect(() => {
        dispatch(getTests(setIsLoading, toast))
    }, [dispatch])
    return (
        <div className={style.mainDiv}>
            <Helmet>
                <title>Exams | Secure Examination</title>
            </Helmet>
            <h2 className={style.screenHeading}>Upcoming Scheduled Tests</h2>

            {
                isLoading
                    ?
                    <DefaultLoading />
                    :
                    TestListReducer.results.length > 0
                        ?
                        <div className={style.testCardsWrapper}>
                            {
                                TestListReducer.results.map((test, index) => {
                                    return (
                                        <div onClick={() => selectTest(test)} key={index} className={style.testCard}>
                                            <p className={style.cardHeading}>{test.exam_id.subjectName}</p>
                                            <p className={style.cardSubHeading}>{test.exam_id && test.exam_id.examinationGroup && test.exam_id.examinationGroup.name}</p>
                                            <p className={style.dateRange}><span className={style.keyHeading}>Time: </span><span className={style.date}>{defaultDateFormatWithTime(test.startDateTime)}</span> to <span className={style.date}>{defaultDateFormatWithTime(test.endDateTime)}</span></p>
                                            <p className={style.status}><span className={style.keyHeading}>Status: </span>{test.status}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        :
                        <NoDataFound label="Upcoming Tests" />
            }
        </div>

    )
}

export default Exams;